var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-d-flex p-flex-column"},[_c('strong',[_vm._v(_vm._s(_vm.leftToPay)+" €")])])}
var staticRenderFns = []

export { render, staticRenderFns }